import React from "react";
import Icon from "../ui/Icon";

export default function AgendaModal({ open, onClose, title, agendaHtml }) {
  if (!open) return null;

  const stripHtml = (html) =>
    html
      ?.replace(/<[^>]+>/g, "")
      .replace(/\r/g, "")
      .replace(/\n{3,}/g, "\n\n")
      .trim() || "No agenda available.";

  return (
    <div
      className="jt-modalOverlay"
      role="dialog"
      aria-modal="true"
      onMouseDown={onClose}
    >
      <div className="jt-sheet" onMouseDown={(e) => e.stopPropagation()}>
        <div className="jt-sheetHead">
          <div className="jt-sheetTitle">
            <span className="jt-sheetIcon">📋</span>
            {title || "Meeting Agenda"}
          </div>

          <button
            className="jt-sheetClose"
            onClick={onClose}
            aria-label="Close"
          >
            <Icon name="close" />
          </button>
        </div>

        <div className="jt-sheetBody">
          <div className="jt-agendaContent" style={{ whiteSpace: "pre-wrap" }}>
            {stripHtml(agendaHtml)}
          </div>
        </div>
      </div>
    </div>
  );
}
